var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-menu-button-list-menu-button"},[_c('div',{staticClass:"outline"},[_c('div',{staticClass:"inline-cover"},[_c('i',{class:_vm.iconName}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"color",style:(`border-color: ${_vm.colorCode}`)})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }